// extracted by mini-css-extract-plugin
export var section = "FullCenteredHeading-module--section--3j4Ts";
export var superText = "FullCenteredHeading-module--super-text--YeiCT";
export var headingCopy = "FullCenteredHeading-module--heading-copy--2s3tT";
export var copy = "FullCenteredHeading-module--copy--33G84";
export var image = "FullCenteredHeading-module--image--2CYtF";
export var wrap = "FullCenteredHeading-module--wrap--2b1FB";